import { PaymentModuleId } from '@foundation/apis/payments';
import { SupportedLanguage } from '@foundation/localization';

import { registerStartupable } from '@/services/base/StartupHelper';

import { getYookassaRedirectUrl } from './YookassaApi';
import { OptionalStartupable } from '../base/Startupable';
import PaymentStore from '../payments/PaymentStore';

class YookassaService implements OptionalStartupable {
  public readonly name = 'YookassaService';
  public readonly moduleId = PaymentModuleId.Yookassa;

  constructor() {
    registerStartupable(this, [PaymentStore]);
  }

  public startup(): Promise<void> {
    return Promise.resolve();
  }

  public shouldStart(): boolean {
    return PaymentStore.allowedPaymentModules.includes(this.moduleId);
  }

  public getRedirectUrl(
    locale: SupportedLanguage,
    accessToken: string,
    telemetryConsent = false,
  ): Promise<string> {
    const paymentIntentId = PaymentStore.paymentIntentId;

    return getYookassaRedirectUrl(
      paymentIntentId,
      accessToken,
      locale,
      telemetryConsent,
    );
  }
}

export default new YookassaService();
